var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.62833C10.4479 3.12059 11.0397 2.76126 11.6968 2.59816C12.354 2.43507 13.0451 2.47594 13.6785 2.71533C14.3118 2.95473 14.8572 3.38131 15.2421 3.9383C15.627 4.49529 15.8332 5.15629 15.8332 5.83333C15.8332 6.51038 15.627 7.17138 15.2421 7.72837C14.8572 8.28536 14.3118 8.71193 13.6785 8.95133C13.0451 9.19073 12.354 9.2316 11.6968 9.06851C11.0397 8.90541 10.4479 8.54608 10 8.03833M12.5 17.5H2.5V16.6667C2.5 15.3406 3.02678 14.0688 3.96447 13.1311C4.90215 12.1935 6.17392 11.6667 7.5 11.6667C8.82608 11.6667 10.0979 12.1935 11.0355 13.1311C11.9732 14.0688 12.5 15.3406 12.5 16.6667V17.5ZM12.5 17.5H17.5V16.6667C17.5001 15.7889 17.2692 14.9266 16.8304 14.1664C16.3916 13.4062 15.7604 12.7749 15.0003 12.336C14.2402 11.8971 13.3779 11.666 12.5002 11.666C11.6224 11.6659 10.7601 11.897 10 12.3358M10.8333 5.83333C10.8333 6.71739 10.4821 7.56524 9.85702 8.19036C9.2319 8.81548 8.38405 9.16667 7.5 9.16667C6.61594 9.16667 5.7681 8.81548 5.14298 8.19036C4.51786 7.56524 4.16667 6.71739 4.16667 5.83333C4.16667 4.94928 4.51786 4.10143 5.14298 3.47631C5.7681 2.85119 6.61594 2.5 7.5 2.5C8.38405 2.5 9.2319 2.85119 9.85702 3.47631C10.4821 4.10143 10.8333 4.94928 10.8333 5.83333Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClients);
export default __webpack_public_path__ + "static/media/icon_clients.c21e4fca254cc825bb83a92c9b886cda.svg";
export { ForwardRef as ReactComponent };